/**
 * Rakentaa kuukaudesta matriisin, elikkäs 5x7 tai 6x7 taulukon.
 * [
 *  [Date, Date, Date, Date, Date, Date, Date],
 *  ...
 * ]
 *
 * Robotti ruttusen koodia :)
 */
export const generateCalendarMatrix = (year, month) => {
  const kuukaudenEka = new Date(year, month, 1);
  const viikonEka = kuukaudenEka.getDay();
  // Datessa sunnuntai = 0 --> muunnetaan maanantai = 0 jne
  const offset = viikonEka === 0 ? 6 : viikonEka - 1;

  // const paiviaKuukaudessa = new Date(year, month + 1, 0).getDate();
  // const paiviaEdellisessaKuukaudessa = new Date(year, month, 0).getDate();

  const matrix = [];
  let currentPaiva = 1 - offset;

  for (let viikko = 0; viikko < 6; viikko++) {
    const rivi = [];

    for (let i = 0; i < 7; i++) {
      const date = new Date(year, month, currentPaiva);
      rivi.push(date);
      currentPaiva++;
    }

    matrix.push(rivi);
  }

  return matrix;
};

/**
 * Tämä puolestaan rakentaa saatavuusdatasta kalenterin solukomponenttien haluamaa dataa
 */
export const buildAvailabilityMap = (availabilityArray) => {
  const map = {};

  availabilityArray.forEach((item) => {
    const dateKey = item.date;
    const bookings = item.bookings || [];
    map[dateKey] = {
      available: item.available ?? Math.max((item.total ?? 0) - (item.booked ?? 0), 0),
      reserved: item.booked ?? bookings.length,
      reservationIds: bookings,
      barPosition: null,
    };
  });

  const byReservationId = {};

  availabilityArray.forEach((item) => {
    const bookings = item.bookings || [];
    const dateKey = item.date;

    bookings.forEach((resId) => {
      if (!byReservationId[resId]) byReservationId[resId] = [];
      byReservationId[resId].push(dateKey);
    });
  });

  Object.values(byReservationId).forEach((dates) => {
    const sorted = dates.slice().sort();

    sorted.forEach((date, index) => {
      const first = index === 0;
      const last = index === sorted.length - 1;

      map[date].barPosition
        = first && last
          ? 'single'
          : first
            ? 'start'
            : last
              ? 'end'
              : 'middle';
    });
  });

  return map;
};

export const formatDateKey = (date) => {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};
